<template>
  <div
    id="reset-link"
    class="md:tw-w-96 tw-w-11/12 tw-flex tw-flex-col tw-items-center tw-pb-8"
  >
    <OnboardingHeader headerText="Enter your email" />
    <OnboardingSubHeader
      subHeaderText="A reset link would be sent to your email address"
    />
    <RequestLinkForm @submitData="submitData" />
    <div class="tw-flex tw-mt-6">
      <p class="tw-text-sm tw-text-gray">Remembered password?</p>
      &nbsp;
      <router-link to="/onboarding/signin" class="tw-text-sm tw-text-primary">
        Sign In
      </router-link>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import OnboardingHeader from "@/components/onboarding/OnboardingHeader.vue";
  import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader.vue";
  import RequestLinkForm from "@/components/onboarding/forms/RequestLinkForm.vue";
  import { emailUrl } from "@/utils/helpers";

  export default {
    name: "RequestLink",

    components: { OnboardingHeader, OnboardingSubHeader, RequestLinkForm },

    methods: {
      ...mapActions("organisationModule", ["resetPasswordLink"]),
      ...mapActions("loadingModule", [
        "requestLinkSuccess",
        "requestLinkLoading",
      ]),
      ...mapActions(["showToast"]),
      emailUrl,
      async submitData(payload) {
        this.requestLinkLoading(true);
        const url = `${this.emailUrl()}/new-password`;
        const response = await this.resetPasswordLink({
          ...payload,
          mail_base_url: url,
        });
        if (response) {
          this.requestLinkSuccess(true);
          const { message } = response.data;
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          this.$router.push("/onboarding/signin");
        }
        this.requestLinkLoading(false);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
